<template>
    <MainContent>
        <template v-slot:header>
            <PageTitle title="Detalles de la indumentaria"/>
        </template>
        <template v-slot:content>
            <div class="table-responsive has-options">
                <b-table hover :items="items" :fields="fields" id="indumentarias-table">
                    <template #cell(tallas)="{ item }">
                        {{ item.tallas.length > 1 ? item.tallas.map(i => i.nombre).join(', ') : item.tallas.map(i => i.nombre).join('') }}
                    </template>
                    <template #cell(imagen)="{ item }">
                        <img :src="item.imagen" style="max-height: 100px"/>
                    </template>
                </b-table>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import PageTitle from '@/components/backend/components/PageTitleComponent';

    export default {
        name: "DetalleIndumentaria",
        data() {
            return {
                indumentaria: null,
                indumentaria_id: this.$route.params.indumentaria_id,
                loading: false,
                fields: [
                    { key: 'nombre', label: 'Nombre', class: 'text-center' },
                    { key: 'tallas', label: 'Talla', class: 'text-center' },
                    { key: 'precio', label: 'Precio', class: 'text-center' },
                    { key: 'imagen', label: 'Imagen', class: 'text-center' },
                ],
                items: null
            }
        },
        created() {
            this.getIndumentaria();
        },
        methods: {
            getIndumentaria() {
                this.loading = true;
                const params = {
                    lista_id: this.lista_id,
                    indumentaria_id: this.indumentaria_id,
                    filters: {}
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.indumentarias.show'), params).then(res => {
                    this.indumentaria = res.data.data;
                    this.items = [{
                        nombre: this.indumentaria.nombre,
                        tallas: this.indumentaria.tallasSelect,
                        precio: this.indumentaria.precio,
                        imagen: this.indumentaria.imagen_formatted
                    }];
                    this.loading = false;
                });
            }
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        components: {
            MainContent, PageTitle
        }
    }
</script>